var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUkFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_339_3527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V32H0V0Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6875 0L19.9375 12.0667L35.125 0H40V4.13333L25 16.0667L40 27.9333V32H35L20 20.0667L5.0625 32H0V28L14.9375 16.1333L0 4.26667V0H4.6875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 18.7333L40 29.3333V32L23.0625 18.7333H26.5ZM15 20.0667L15.375 22.4L3.375 32H0L15 20.0667ZM40 0V0.2L24.4375 12.7333L24.5625 9.8L36.875 0H40ZM0 0L14.9375 11.7333H11.1875L0 2.8V0Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0625 0V32H25.0625V0H15.0625ZM0 10.6667V21.3333H40V10.6667H0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12.8667V19.2667H40V12.8667H0ZM17.0625 0V32H23.0625V0H17.0625Z",
    fill: "#C8102E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_339_3527"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 32,
    rx: 4,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkFlag);
export default __webpack_public_path__ + "static/media/UKFlag.c23f5163.svg";
export { ForwardRef as ReactComponent };